import * as TWEEN from '@tweenjs/tween.js';
import { Camera, Raycaster, Vector2, Vector3, MathUtils } from 'three';

export const getCurrentCameraLookPoint = (
  camera?: Camera
): { x: number; y: number; z: number } => {
  const scene = window.scene;
  if (!camera) camera = window.camera;
  const raycaster = new Raycaster();
  raycaster.setFromCamera(new Vector2(), camera);
  const intersects = raycaster.intersectObjects(scene.children, true);
  if (intersects.length) {
    const closestPoint = intersects[0].point;
    return { x: closestPoint.x, y: closestPoint.y, z: closestPoint.z };
  }
  return { x: 0, y: 0, z: 0 };
};

export const createCameraLook = (
  endPoint: { x?: number; y?: number; z?: number },
  duration = 1000,
  camera?: Camera
): TWEEN.Tween<Record<string, number>> => {
  if (!camera) camera = window.camera;
  const startLook = getCurrentCameraLookPoint(camera);
  const endLook = {
    x: typeof endPoint.x === 'number' ? endPoint.x : startLook.x,
    y: typeof endPoint.y === 'number' ? endPoint.y : startLook.y,
    z: typeof endPoint.z === 'number' ? endPoint.z : startLook.z,
  };
  const startLatLon = { lat: window.lat, lon: window.lon };
  const endLatLon = getLatLonFromPoint(endLook.x, endLook.y, endLook.z);
  const animateLook = new TWEEN.Tween(startLatLon).to(endLatLon, duration);
  animateLook.onUpdate(function () {
    window.lat = startLatLon.lat;
    window.lon = startLatLon.lon;
  });

  animateLook.onComplete(() => {
    window.dispatchEvent(new Event('next-event'));
  });
  return animateLook;
};

export const createCameraMove = (
  endSpot: { x?: number; y?: number; z?: number },
  duration = 1000,
  camera?: Camera
): TWEEN.Tween<Record<string, number>> => {
  if (!camera) camera = window.camera;
  const startPoint = {
    x: camera.position.x,
    y: camera.position.y,
    z: camera.position.z,
  };
  const endPoint = {
    x: typeof endSpot.x === 'number' ? endSpot.x : startPoint.x,
    y: typeof endSpot.y === 'number' ? endSpot.y : startPoint.y,
    z: typeof endSpot.z === 'number' ? endSpot.z : startPoint.z,
  };

  const animateMove = new TWEEN.Tween(startPoint).to(endPoint, duration);
  animateMove.onUpdate(function () {
    camera?.position.set(startPoint.x, startPoint.y, startPoint.z);
  });
  animateMove.onComplete(() => {
    window.dispatchEvent(new Event('next-event'));
  });
  return animateMove;
};

const getLatLonFromPoint = function (x: number, y: number, z: number) {
  const point = new Vector3(-x, y, z);
  point.normalize();
  // const theta = Math.atan2(
  //   point.y,
  //   Math.sqrt(point.x * point.x + point.z * point.z)
  // );
  // const phi = Math.atan2(point.z, point.x);
  // const lat = 90 - MathUtils.radToDeg(phi);
  // const lon = MathUtils.radToDeg(theta);
  const lat = 90 - (Math.acos(point.y) * 180) / Math.PI;
  const lon =
    ((270 + (Math.atan2(point.x, point.z) * 180) / Math.PI) % 360) - 180;
  return { lat, lon };
};

window.getLatLon = getLatLonFromPoint;
